<template>
  <div class="ticket-border">
    <table class="ticket-table" cellSpacing="0" cellPadding="0">
      <tbody>
        <!-- zero height row to fix column width -->
        <tr class="zero-height-row">
          <td style="width: 160px;"></td>
          <td style="width: 30px;"></td>
          <td style="width: 230px;"></td>
          <td style="width: 15px;"></td>
          <td style="width: 230px;"></td>
          <td style="width: 15px;"></td>
          <td style="width: 230px;"></td>
          <td style="width: 10px;"></td>
        </tr>
        <tr>
          <td class="ticket-logo" rowspan="2">
            <img :src="logoImg" width="90%" alt="Logo" />
          </td>
          <td class="ticket-separator-rt" rowspan="2">
            <div class="ticket-separator-top">
              <img :src="topCircleImg" alt="" />
            </div>
          </td>
          <td class="has-text-centered" colspan="6">
            <span class="ticket-title-font ticket-title">
              {{$t(isReserv ? 'boarding.ticket.title' : 'boarding.ticket.paidtitle')}}
            </span>
          </td>
        </tr>
        <tr>
          <td class="ticket-table-wrap-common-info-headed">
            <span class="ticket-title-font">{{$t('boarding.ticket.route')}}</span>
            <span class="ticket-title-font-eng-inline">Flight</span>
            <span class="ticket-info-font">{{ticket.raceNum}} {{ticket.raceName}}</span>
          </td>
          <td class="ticket-column-space" />
          <td class="ticket-table-wrap-common-info-headed">
            <span class="ticket-title-font">{{$t('boarding.ticket.departure')}}</span>
            <span class="ticket-title-font-eng-inline">Departure</span>
            <span class="ticket-info-font">
              {{ticket.dateDep}} / {{ticket.timeDep}}
            </span>
            <span class="ticket-info-font">{{ticket.stDepName}}</span>
            <span class="ticket-info-font-small">
                {{ticket.stDepAddr}}
                <span v-if="ticket.platform">({{$t('boarding.ticket.platform')}} {{ticket.platform}})</span>
            </span>
          </td>
          <td class="ticket-column-space" />
          <td class="ticket-table-wrap-common-info-headed">
            <span class="ticket-title-font">{{$t('boarding.ticket.arrival')}}</span>
            <span class="ticket-title-font-eng-inline">Arrival</span>
            <span class="ticket-info-font">
              {{ticket.dateArr}} / {{ticket.timeArr}}
            </span>
            <span class="ticket-info-font">{{ticket.stArrName}}</span>
            <span class="ticket-info-font-small">{{ticket.stArrAddr}}</span>
          </td>
          <td class="ticket-column-space" />
        </tr>
        <tr>
          <td class="ticket-first-column-reserve" v-if="isReserv">
            <span class="ticket-title-font">{{$t('boarding.ticket.ordered')}}</span>
            <span class="ticket-title-font-eng-inline">Ordered</span>
            <span class="ticket-info-font">
              {{common.createdAt.date}} {{common.createdAt.time}}<span class="ticket-timezone">{{" (" + common.createdAt.timezone + ")"}}</span>
            </span>
            <span v-if="!common.bookingExpiresAt">
              <span class="ticket-title-font">{{$t('boarding.ticket.onboarding')}}</span>
            </span>
            <span v-else>
              <span class="ticket-title-font">{{$t('boarding.ticket.payup')}}</span>
              <span class="ticket-title-font-eng-inline">Pay up</span>
              <span class="ticket-info-font">
                {{common.bookingExpiresAt.date}} {{common.bookingExpiresAt.time}}<span class="ticket-timezone">{{" (" + common.bookingExpiresAt.timezone + ")"}}</span>
              </span>
            </span>
          </td>
          <td class="ticket-first-column" v-else>
            <span class="ticket-title-font">{{$t('boarding.ticket.sales')}}</span>
            <span class="ticket-title-font-eng-inline">Sales</span>
            <span class="ticket-info-font">
              {{ticket.paidAt.date}} {{ticket.paidAt.time}}<span class="ticket-timezone">{{" (" + ticket.paidAt.timezone + ")"}}</span>
            </span>
          </td>
          <td class="ticket-separator" />
          <td class="ticket-table-wrap-common-info2">
            <span class="ticket-title-font">{{$t('boarding.ticket.passenger')}}</span>
            <span class="ticket-title-font-eng-inline">Passenger</span>
            <span class="ticket-info-font">{{ticket.fio}}</span>
          </td>
          <td class="ticket-column-space" />
          <td class="ticket-table-wrap-common-info2">
            <span class="ticket-title-font">{{$t('boarding.ticket.seat')}}</span>
            <span class="ticket-title-font-eng-inline">Seat</span>
            <span class="ticket-info-font">{{ticket.place}}</span>
          </td>
          <td class="ticket-column-space" />
          <td class="ticket-table-wrap-common-info2">
            <span class="ticket-title-font">{{$t('boarding.ticket.carrier')}}</span>
            <span class="ticket-title-font-eng-inline">Carrier</span>
            <span class="ticket-info-font">{{ticket.carrierName}}</span>
          </td>
          <td class="ticket-column-space" />
        </tr>
        <tr>
          <td class="ticket-first-column ticket-last-row">
            <div class="ticket-site">
              <a :href="host">
                <i>{{host}}</i>
              </a>
            </div>
            <img :src="QRCodeImg" alt="QRcode" />
            <span class="ticket-number">№ {{number}}</span>
          </td>
          <td class="ticket-separator-rb">
            <div class="ticket-separator-bottom">
              <img :src="bottomCircleImg" alt="" />
            </div>
          </td>
          <td colSpan="6" class="ticket-table-wrap">
            <table cellSpacing="0" cellPadding="0">
              <tbody>
                <tr>
                  <td class="ticket-bottom-border ticket-money">
                    <span class="ticket-title-font">{{$t('boarding.ticket.fee')}}</span>
                    <span class="ticket-title-font-eng-wrap">Fee/Service</span>
                    <span class="ticket-info-font">{{ticket.feesPrice||""}}</span>
                  </td>
                  <td class="ticket-bottom-border ticket-money">
                    <span class="ticket-title-font">{{$t('boarding.ticket.passage')}}</span>
                    <span class="ticket-title-font-eng-wrap">Passage</span>
                    <span class="ticket-info-font">{{ticket.passagePrice}}</span>
                  </td>
                  <td class="ticket-column-space ticket-bottom-border" />
                  <td class="ticket-bottom-border ticket-money">
                    <span class="ticket-title-font">{{$t('boarding.ticket.luggage')}}</span>
                    <span class="ticket-title-font-eng-wrap">Luggage</span>
                    <span class="ticket-info-font">{{luggagePrice}}</span>
                  </td>
                  <td class="ticket-column-space ticket-bottom-border" />
                  <td class="ticket-bottom-border ticket-money">
                    <span class="ticket-title-font">{{$t('boarding.ticket.type')}}</span>
                    <span class="ticket-title-font-eng-wrap">Type</span>
                    <span class="ticket-info-font">{{ticket.discType}}</span>
                  </td>
                  <td class="ticket-column-space ticket-bottom-border" />
                  <td class="ticket-bottom-border ticket-money">
                    <span class="ticket-title-font">{{$t('boarding.ticket.discount')}}</span>
                    <span class="ticket-title-font-eng-wrap">Discount</span>
                    <span class="ticket-info-font">{{ticket.discount}}</span>
                  </td>
                  <td class="ticket-column-space ticket-bottom-border" />
                  <td class="ticket-bottom-border ticket-money">
                    <span class="ticket-title-font">
                      {{ $t('boarding.ticket.total', { currency: currencySymbol }) }}
                    </span>
                    <span class="ticket-title-font-eng-wrap">Total, {{ common.curr }}</span>
                    <span class="ticket-total-price">{{ticket.price}}</span>
                  </td>
                  <td class="ticket-column-space" />
                </tr>
                <tr>
                  <td colSpan="4" class="ticket-footer" v-if="ticket.insurName">
                    <span class="ticket-title-font">{{$t('boarding.ticket.insurance')}}</span>
                    <span class="ticket-title-font-eng-inline">Insurance</span>
                    <span class="ticket-info-font">{{$t('boarding.ticket.insuranceText')}}</span>
                    <span class="ticket-info-font-small">{{insurance}}</span>
                  </td>
                  <td colSpan="4" class="ticket-footer" v-else />
                  <td class="ticket-column-space" />
                  <td colSpan="5" class="ticket-footer">
                    <span class="ticket-title-font">{{$t('boarding.ticket.support')}}</span>
                    <span class="ticket-title-font-eng-inline">Support service</span>
                    <div class="ticket-phones">
                      <span>{{phonesSupport[0] || ""}}</span>
                      <span>{{phonesSupport[1] || ""}}</span>
                    </div>
                    <div class="ticket-phones">
                      <span v-if="phonesSupport[2]">{{phonesSupport[2]}}</span>
                      <span v-if="phonesSupport[3]">{{phonesSupport[3]}}</span>
                    </div>
                    <div class="ticket-phones">
                      <span v-if="phonesSupport[4]">{{phonesSupport[4]}}</span>
                      <span v-if="phonesSupport[5]">{{phonesSupport[5]}}</span>
                    </div>
                  </td>
                  <td class="ticket-column-space" />
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import topCircle from '@/assets/img/ticket_top_circle.png';
import bottomCircle from '@/assets/img/ticket_bottom-circle.png';

export default {
  name: 'BoardingTicket',
  props: {
    common: {
      type: Object,
      required: true,
    },
    ticket: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    isReserv() {
      return !!this.common.reserve;
    },
    number() {
      return this.isReserv ? this.common.orderNum : this.ticket.ticketNum;
    },
    insurance() {
      return `${this.ticket.insurName}${this.ticket.insurAddr ? `, ${this.ticket.insurAddr}` : ''}`;
    },
    luggagePrice() {
      return this.ticket.luggagePrice ? this.ticket.luggagePrice : '-';
    },
    host() {
      return this.ticket.brand.site;
    },
    isOnBoarding() {
      return this.$frameparams.reservemode === 2;
    },
    topCircleImg() {
      return topCircle;
    },
    bottomCircleImg() {
      return bottomCircle;
    },
    logoImg() {
      return this.ticket.brand.logo ? this.ticket.brand.logo.data : '';
    },
    QRCodeImg() {
      return this.ticket.brand.qrcode ? this.ticket.brand.qrcode.data : '';
    },
    phonesSupport() {
      const { phones } = this.ticket.brand;
      return (phones || []).map(phone => phone.number);
    },
    currencySymbol() {
      const name = this.$root.octobusCurrency ? this.$root.octobusCurrency.name : '';
      const currency = name || this.$root.octobusCurrencyObj;

      return typeof currency === 'object' ? currency.name : currency;
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/BoardingTicket/BoardingTicket.vue